import React, { Component } from 'react';
import GS from '../../grafsync/grafsync';

const EventContext = React.createContext();

export const EventConsumer = EventContext.Consumer;

class EventProvider extends Component {

    state = {
        event: null,
        eventMonitor: null
    };

    componentDidMount() {
        const em = GS.register(this.processStream);
        this.eventMonitor = () => em;
    }

    processStream = (data) => {
        this.setState({ event: data });
    };

    componentWillUnmount() {
        const em = this.eventMonitor();
        GS.unregister(em);
    }

    render() {
        return (
            <EventContext.Provider value={{event: this.state.event}}>
                {this.props.children}
            </EventContext.Provider>
        );
    }
}

export default EventProvider;
